import {useContext} from 'react'
import {SupplierReportContext} from '../../context'
import {DynamicTable} from '../../../../components/DynamicTable'
import {SUPPLIER_REPORT_COLUMNS} from '../../utils'
import SupplierReportRow from './SupplierReportRow'
import {parseSupplierReportRow} from '../../parsings'

const SupplierReportTable = () => {
  const {reportData, isLoading, filters, onSortingChange} = useContext(SupplierReportContext)

  return (
    <div className='sticky-table-wrapper'>
      <div className='table-responsive-wrapper'>
        <div className='table-responsive'>
          <DynamicTable
            data={reportData}
            sortableColumns={SUPPLIER_REPORT_COLUMNS}
            loading={isLoading}
            TableRow={SupplierReportRow}
            noDataMessage='No supplier reports found'
            filters={filters}
            onSortingChange={onSortingChange}
            tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'
            tableHeaderClass='sticky-table-header'
            rowParsingFunction={parseSupplierReportRow}
          />
        </div>
      </div>
    </div>
  )
}

export default SupplierReportTable
